import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ClinicalFocus } from 'components/types/ClinicalFocusTypes';

/* eslint-disable prettier/prettier */
export type LocationTypeFields = {
  Description: {
    value: string;
  };
};

export type LocationType = {
  displayName: string;
  id: string;
  name: string;
  url: string;
  fields: LocationTypeFields;
};

export type Provider = {
  name?: string;
  FirstName?: {
    value: string;
  };
  LastName?: {
    value: string;
  };
  NPI?: {
    value: string;
  };
  Degrees: {
    value: string;
  };
  ExternalID?: {
    value: string;
  };
  FullName: {
    value: string;
  };
  Gender: {
    value: string;
  };
  ProfileUrl?: string;
  ProviderImage: {
    value: string;
  };
  Specialty?: {
    value: string;
  };
  ClinicalFocus: {
      value?: Array<ClinicalFocus>;
  };
};

export type MetaProvider = {
  Specialty?: {
    value: string;
  };
};

export type Providers = {
  HasProviders: boolean;
  ProviderCount: number;
  SpecialtyGroups: {
    [key: string]: Array<Provider>;
  };
};

export type LocationFields = {
  id: string;
  name: string;
  About: {
    value: string;
  };
  Parking: {
    value: string;
  };
  PrepareForYourFirstVisit: {
    value: string;
  };
    CommittedToExcellence: {
    value: string;
  };
  AllProviders: string;
    BookOnlineOverrideUrl: {
    value: string;
    };
  City: {
    value: string;
  };
  EpicDeptId: {
    value: string;
  };
  EpicProviderId: {
    value: string;
  };
  HideInsuranceAccepted: {
    value: string;
  };
  HoursOfOperation: {
    value: string;
  };
  HoursOfOperationNotes?: {
    value: string;
  };
  Latitude: {
    value: string;
  };
  LocationId: {
    value: string;
  };
  LocationImage: {
    value: {
      alt: string;
      height: string;
      src: string;
      thumbnailsrc: string;
      width: string;
    };
  };
  LocationName: {
    value: string;
  };
  LocationTypes: {
    value: Array<LocationType>;
  };
  Longitude: {
    value: string;
  };
  Phone: {
    value: string;
  };
  Providers: Providers;

  ServicesOffered: {
    value: string;
  };
  State: {
    value: string;
  };
  Street1: {
    value: string;
  };
  Street2: {
    value: string;
  };
  Suite: {
    value: string;
  };
  Zip: {
    value: string;
  };
  PublishToLocal: {
    value: boolean;
  };
};

export type LocationMetaFields = {
  id: string;
  City: {
    value: string;
  };
  LocationName: {
    value: string;
  };
  LocationId: {
    value: string;
  };
  Phone: {
    value: string;
  };
  State: {
    value: string;
  };
  Street1: {
    value: string;
  };
  Zip: {
    value: string;
  };
  LocationImage: ImageField;
  SchemaText?: {
    value: string;
  };
};

export type LocationItem = {
  distance: number | null;
  id: string;
  name: string;
  fields: LocationFields;
};

export type HoursOfOperation = {
  closeDay: string;
  closeTime: string;
  openDay: string;
  openTime: string;
};

export type Time = {
  DayOfWeek: string;
  OpenTime: string;
  CloseTime: string;
  Open24Hours: boolean;
};

export type Day = {
  id: string;
  open: string;
  close: string;
  open24Hours: boolean;
};
